import { createFileRoute } from '@tanstack/react-router';

import { AdvisorsTab } from '../../../components';

const Page = () => {
  const params = Route.useParams();
  return <AdvisorsTab advisoryOrganizationId={params.advisoryOrganizationId} />;
};

export const Route = createFileRoute(
  '/organizations/$advisoryOrganizationId/advisors'
)({
  component: Page
});
